
import axios from 'axios'

const authWithBackend = async () => {
    let token = localStorage.getItem('bearerToken')
    let user = localStorage.getItem('loggedInUserEmail')
    let idToken = localStorage.getItem('googleIdToken')
    let authenticated = false

    if ((user === null) || (user === 'null')) {
        return
    }

    const requestFreshToken = async () => {
        const tokenData = await axios.post('/v1/fetchAuthToken', {
            authenticatedUser: user,
            idToken: idToken || undefined
        })
        return tokenData.data.token
    }

    try {
        if ((token === 'null') || (token === null) || (token === 'undefined')) {
            token = await requestFreshToken()
        }
        let config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        let userData
        try {
            userData = await axios.get('/v1/userentries', config)
        } catch (err) {
            if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                token = await requestFreshToken()
                config = { headers: { Authorization: `Bearer ${token}` } }
                userData = await axios.get('/v1/userentries', config)
            } else {
                throw err
            }
        }
        let users = userData.data
        users.forEach(usr => {
            if (usr.name === user)
                authenticated = true
        })
        if (authenticated && token) {
            localStorage.setItem('bearerToken', token)
        }
    } catch (authErr) {
        console.error('Authentication check failed:', authErr)
    }
}

export { authWithBackend }

